import { type WritableDraft } from 'immer';

import { type Workflow } from '@blaze-shared/workflow-domain';

import { type EngineState } from '../../../+state/engine';
import { wireLayoutWorkflowInputs } from '../../../ai';
import type { ElementDefinitionsService } from '../../../services/element-definitions.service';

import {
  SCHEDULER_INPUT_TOKEN,
  SCHEDULER_RESOLVED_INPUT,
  type SchedulerContext,
} from './scheduler.definition';

export function wireSchedulerWorkflowInputs(
  draft: WritableDraft<EngineState>,
  context: SchedulerContext,
  workflow: Workflow,
  elementDefinitions: ElementDefinitionsService,
): boolean {
  return wireLayoutWorkflowInputs(
    draft,
    context,
    workflow,
    elementDefinitions,
    new Map([[SCHEDULER_INPUT_TOKEN, { name: SCHEDULER_RESOLVED_INPUT, eventType: 'change' }]]),
  );
}
